import React from 'react';
import { Button } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import './styles/benefitCard.scss';

function BenefitCardComponent(props) {

  const { benefit, benefitId } = props;

  const handleClick = () => {
    if (benefit.benefitType === 'CUSTOM') props.history.push(`/ayudas/${benefit._id}`);
    else props.history.push(`/ayudas/${benefitId}`);
  };

  return (
    <div className="benefit-card-component">
      <div className="benefit-thumbnail-container">
        <div className="benefit-thumbnail" style={{ backgroundImage: `url(${benefit.thumbnail})` }} />
      </div>
      <div style={{ paddingLeft: '20px', paddingRight: '20px' }}>
        <div className="benefit-name">{benefit.name}</div>
        <Button onClick={handleClick} className="app-button benefit-button">
          Ver más
        </Button>
      </div>
    </div>
  );
}

export default withRouter(BenefitCardComponent);
